import { CoreUsersByIdSalesforcePreferencesName } from './name';
import { coreUsersByIdSalesforcePreferencesUpdateSyncSlice } from './update';
import { patchUserSalesforcePreferences } from '@api';

import { AMPLITUDE_EVENT, createLogSaga } from '@sonar-software/sonar-analytics';
import { createPatchAsyncSlice, SagaYieldType } from '@sonar-software/xuder';

export const coreUsersByIdSalesforcePreferencesPatchAsyncSlice = createPatchAsyncSlice({
	additionalRequestSteps: [
		{
			actionHandler: createLogSaga(AMPLITUDE_EVENT.SALESFORCE_LIGHTING_URL_PREFERENCE_UDPATED, ({ data }) => ({
				...data
			})),
			type: SagaYieldType.Every
		}
	],
	httpSagaOptions: {
		preRequestActionCreators: [ coreUsersByIdSalesforcePreferencesUpdateSyncSlice.syncActionCreator ]
	},
	name: CoreUsersByIdSalesforcePreferencesName,
	receive: false,
	request: true,
	requestHandler: patchUserSalesforcePreferences
});
